import { render, staticRenderFns } from "./assetsDetail.vue?vue&type=template&id=70136d37&scoped=true&"
import script from "./assetsDetail.vue?vue&type=script&lang=js&"
export * from "./assetsDetail.vue?vue&type=script&lang=js&"
import style0 from "./assetsDetail.vue?vue&type=style&index=0&id=70136d37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70136d37",
  null
  
)

export default component.exports